import React, { FunctionComponent } from 'react';
import { Checkbox, Fieldset, Heading, Layout, Pagination, Table } from '@vwfs-bronson/bronson-react';

import { MockSearchCustomerFormModel, MockSearchCustomerItem } from './formModel';

interface CustomerSearchModalTableProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  handlePageChange: (page: number) => void;
  searchResults: MockSearchCustomerItem[];
  hasSearched: boolean;
  lastSearchValues: MockSearchCustomerFormModel | null;
  selectedCustomerId: string | null;
  setSelectedCustomerId: (id: string | null) => void;
  t: (key: string, options?: Record<string, unknown>) => string;
}

export const CustomerSearchModalTable: FunctionComponent<CustomerSearchModalTableProps> = ({
  currentPage,
  totalPages,
  handlePageChange,
  searchResults,
  hasSearched,
  lastSearchValues,
  selectedCustomerId,
  setSelectedCustomerId,
  totalItems,
  t,
}) => {
  return (
    <Fieldset>
      <Heading level={4} className="u-text-left">
        {t('customerSearchModal:private:table:results')} ({totalItems})
      </Heading>
      {hasSearched && searchResults.length === 0 && (
        <p className="u-text-left">{t('customerSearchModal:private:table:noResultsFound')}</p>
      )}
      {searchResults.length > 0 && (
        <>
          <Table>
            <React.Fragment key=".0">
              <Table.Thead>
                <Table.Tr>
                  <Table.Th />
                  <Table.Th>{t('customerSearchModal:private:table:headers:name')}</Table.Th>
                  <Table.Th>{t('customerSearchModal:private:table:headers:address')}</Table.Th>
                  <Table.Th>{t('customerSearchModal:private:table:headers:phoneNumber')}</Table.Th>
                  <Table.Th>{t('customerSearchModal:private:table:headers:emailAddress')}</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {searchResults.map((result) => (
                  <Table.Tr key={result.id}>
                    <Table.Td>
                      <Checkbox
                        name={`result-${result.id}`}
                        checked={selectedCustomerId === result.id}
                        onChange={() => {
                          const isUnselect = selectedCustomerId === result.id;
                          const nextId = isUnselect ? null : (result.id ?? null);
                          setSelectedCustomerId(nextId);
                        }}
                      />
                    </Table.Td>
                    <Table.Td>
                      {result.firstName} {result.lastName}
                    </Table.Td>
                    <Table.Td>{result.address}</Table.Td>
                    <Table.Td>
                      {result.countryCode} {result.mobileNumber}
                    </Table.Td>
                    <Table.Td>{result.email}</Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </React.Fragment>
          </Table>
          {lastSearchValues && (
            <Layout center className="u-mt">
              <Pagination
                testId="pagination_customerSearchResults"
                title={t('searchPage:results.pagination.pageInfo', { currentPage, totalPages })}
                onPrevClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                onNextClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
                prevDisabled={currentPage === 1}
                nextDisabled={currentPage === totalPages}
              >
                {Array.from({ length: totalPages }, (_, index) => index + 1).map((page) => (
                  <Pagination.Item key={page} active={page === currentPage} onClick={() => handlePageChange(page)}>
                    {page}
                  </Pagination.Item>
                ))}
              </Pagination>
            </Layout>
          )}
        </>
      )}
    </Fieldset>
  );
};
